<app-ui-select
  [label]="label"
  [control]="control"
  [description]="description"
  [required]="required"
  [options]="timeOptions"
  [isMultiple]="false"
  (changeHandler)="changeHandler.emit($event.value)"
></app-ui-select>
